import { socket } from '../core/socket.js';
import { state } from '../core/state.js';
import { t } from '../core/i18n.js';
import { popToast, chaosNotify } from '../utils/alerts.js';
import { formatSmartDate } from '../utils/formatters.js';

// ==========================================================================
//   MODÉRATION
// ==========================================================================

let messageSignaleId = null;
let signalementCibleMute = null;
let mesCapacitesModeration = { estModoQuelquePart: false, estAdminGlobal: false };

socket.on('moderation-mon-role-maj', ({ role }) => {
    const ancienRole = state.monRoleGlobal;
    state.monRoleGlobal = role || 'user';
    if (state._monRoleGlobalInitialise && ancienRole !== state.monRoleGlobal) {
        if (state.monRoleGlobal === 'modo' || state.monRoleGlobal === 'admin') {
            popToast(t('toast.role_promoted', { role: t('role.' + state.monRoleGlobal) }), 'success');
        } else if (state.monRoleGlobal === 'user') {
            popToast(t('toast.role_demoted'), 'error');
        }
    }
    state._monRoleGlobalInitialise = true;
    socket.emit('moderation-demander-count');
});

// --- 1. MODALE DE SIGNALEMENT ---

export function ouvrirModalReport(messageId) {
    messageSignaleId = messageId;
    document.getElementById('report-motif').value = 'spam';
    document.getElementById('report-details').value = '';
    document.getElementById('modal-report').style.display = 'flex';
}

export function fermerModalReport() {
    document.getElementById('modal-report').style.display = 'none';
    messageSignaleId = null;
}

export function validerReport() {
    if (!messageSignaleId) return;
    const motif   = document.getElementById('report-motif').value;
    const details = document.getElementById('report-details').value.trim();
    socket.emit('signaler-message', { messageId: messageSignaleId, motif, details });
    fermerModalReport();
}

socket.on('signalement-confirme', () => {
    popToast(t('toast.report_sent'), "error");
});

// --- 2. PANNEAU MODÉRATION ---

export function toggleModerationPanel() {
    if (state.monRoleGlobal !== 'admin') {
        if (typeof popToast === 'function') {
            popToast("Protocole Inquisition réservé aux administrateurs.", "error");
        }
        return;
    }

    const panel = document.getElementById('moderation-side-panel');
    if (!panel) return;
    panel.classList.toggle('open');

    if (panel.classList.contains('open')) {
        socket.emit('moderation-demander-liste');
    }
}

socket.on('moderation-acces-refuse', () => {
    popToast(t('toast.moderation_no_access') || "Accès refusé.", "error");
    document.getElementById('moderation-side-panel').classList.remove('open');
});

socket.on('moderation-liste', ({ signalements, capacites }) => {
    mesCapacitesModeration = capacites;
    const container = document.getElementById('moderation-list-container');
    container.innerHTML = '';

    if (!signalements || signalements.length === 0) {
        container.innerHTML = `<p style='color: #8b949e; text-align: center; margin-top: 20px;'>${t('moderation.empty')}</p>`;
        return;
    }

    signalements.forEach(sig => {
        let contenuMsg = sig.message_contenu || `<em style="color:#8b949e;">${t('moderation.message_deleted')}</em>`;
        if (sig.message_contenu) {
            try { contenuMsg = DOMPurify.sanitize(marked.parse(sig.message_contenu)); }
            catch (e) { /* fallback */ }
        }

        const motifLabel = t('report.motif_' + sig.motif);
        const ctxLabel   = sig.contexte === 'sphere'
            ? `${sig.sphere_nom || '?'} / #${sig.salon_nom || '?'}`
            : t('moderation.context_mp');
        const dateStr = formatSmartDate(sig.date_signalement);

        const card = document.createElement('div');
        card.className = 'moderation-card';
        card.dataset.signalementId = sig.id;
        card.innerHTML = `
            <div class="mod-card-header">
                <span class="mod-card-motif">🚩 ${motifLabel}</span>
                <span class="mod-card-date">${dateStr}</span>
            </div>
            <div class="mod-card-meta">
                <span style="color:${sig.signaleur_couleur || '#8b949e'};">@${sig.auteur_signalement}</span>
                <span style="color:#8b949e;">→</span>
                <span style="color:${sig.cible_couleur || '#f85149'};">@${sig.cible}</span>
                <span style="color:#8b949e; font-size:0.8em;">(${ctxLabel})</span>
            </div>
            ${sig.details ? `<div class="mod-card-details"><em>"${DOMPurify.sanitize(sig.details)}"</em></div>` : ''}
            <div class="mod-card-message">${contenuMsg}</div>
            <div class="mod-card-actions">
                <button class="mod-action-btn mod-reject" onclick="actionModoRejeter(${sig.id})" title="${t('moderation.action_reject')}"><i class="fas fa-times"></i></button>
                <button class="mod-action-btn mod-warn"   onclick="actionModoAvertir(${sig.id})"  title="${t('moderation.action_warn')}"><i class="fas fa-exclamation-triangle"></i></button>
                <button class="mod-action-btn mod-mute"   onclick="ouvrirModalMute(${sig.id})"    title="${t('moderation.action_mute')}"><i class="fas fa-volume-mute"></i></button>
                <button class="mod-action-btn mod-delete" onclick="actionModoSupprimer(${sig.id})" title="${t('moderation.action_delete')}"><i class="fas fa-trash"></i></button>
            </div>
        `;
        container.appendChild(card);
    });
});

export function actionModoRejeter(signalementId) {
    socket.emit('moderation-rejeter', { signalementId });
}
export function actionModoAvertir(signalementId) {
    socket.emit('moderation-avertir', { signalementId });
}
export async function actionModoSupprimer(signalementId) {
    const ok = await chaosNotify(t('moderation.confirm_delete'), t('moderation.confirm_delete_title'), 'confirm');
    if (ok) socket.emit('moderation-supprimer', { signalementId });
}

socket.on('moderation-action-ok', ({ signalementId }) => {
    const card = document.querySelector(`.moderation-card[data-signalement-id="${signalementId}"]`);
    if (card) {
        card.style.transition = 'opacity 0.3s, transform 0.3s';
        card.style.opacity    = '0';
        card.style.transform  = 'translateX(50px)';
        setTimeout(() => {
            card.remove();
            const container = document.getElementById('moderation-list-container');
            if (!container.querySelector('.moderation-card')) {
                container.innerHTML = `<p style='color: #8b949e; text-align: center; margin-top: 20px;'>${t('moderation.empty')}</p>`;
            }
        }, 300);
    }
    socket.emit('moderation-demander-count');
});

// --- 3. BADGE COMPTEUR ---

socket.on('moderation-count', ({ count, peutModerer }) => {
    const btn   = document.getElementById('btn-moderation');
    const badge = document.getElementById('moderation-badge');
    if (peutModerer && state.monRoleGlobal === 'admin') {
        btn.style.display = 'inline-block';
        if (count > 0) {
            badge.textContent   = count > 99 ? '99+' : count;
            badge.style.display = 'inline-block';
        } else {
            badge.style.display = 'none';
        }
    } else {
        btn.style.display   = 'none';
        badge.style.display = 'none';
    }

    const zoneChangelog = document.getElementById('admin-changelog-zone');
    if (zoneChangelog) {
        zoneChangelog.style.display = (state.monRoleGlobal === 'admin') ? 'block' : 'none';
    }
});

socket.on('moderation-nouveau-signalement', () => {
    socket.emit('moderation-demander-count');
    const panel = document.getElementById('moderation-side-panel');
    if (panel.classList.contains('open')) socket.emit('moderation-demander-liste');
});

// --- 4. MODALE DE MUTE ---

export function ouvrirModalMute(signalementId) {
    signalementCibleMute = signalementId;
    document.getElementById('mute-duree').value        = '60';
    document.getElementById('mute-duree-custom').value = '';
    document.getElementById('mute-custom-row').style.display = 'none';
    document.getElementById('modal-mute').style.display     = 'flex';
}

export function fermerModalMute() {
    document.getElementById('modal-mute').style.display = 'none';
    signalementCibleMute = null;
}

document.addEventListener('change', (e) => {
    if (e.target && e.target.id === 'mute-duree') {
        document.getElementById('mute-custom-row').style.display = (e.target.value === 'custom') ? 'block' : 'none';
    }
});

export function validerMute() {
    if (!signalementCibleMute) return;
    let duree = document.getElementById('mute-duree').value;
    if (duree === 'custom') {
        duree = parseInt(document.getElementById('mute-duree-custom').value, 10);
        if (!duree || duree < 1) { popToast(t('mute.invalid_duration'), 'error'); return; }
    }
    socket.emit('moderation-muter', { signalementId: signalementCibleMute, dureeMinutes: parseInt(duree, 10) });
    fermerModalMute();
}

socket.on('vous-etes-mute', ({ jusqu_a }) => {
    const finStr = new Date(jusqu_a).toLocaleString();
    popToast(t('mute.you_are_muted', { fin: finStr }), 'error');
});

// --- 5. BOOTSTRAP ADMIN ---

export function ouvrirModalBootstrap() {
    document.getElementById('bootstrap-key').value = '';
    document.getElementById('modal-bootstrap').style.display = 'flex';
}

export function fermerModalBootstrap() {
    document.getElementById('modal-bootstrap').style.display = 'none';
}

export function validerBootstrap() {
    const key = document.getElementById('bootstrap-key').value;
    if (!key) return;
    socket.emit('moderation-bootstrap-admin', { masterKey: key });
}

socket.on('moderation-bootstrap-result', ({ success, message }) => {
    popToast(message, success ? 'success' : 'error');
    if (success) {
        fermerModalBootstrap();
        setTimeout(() => socket.emit('moderation-demander-count'), 500);
    }
});

// --- 6. CHANGELOG ADMIN ---

export async function envoyerChangelog() {
    const version = document.getElementById('changelog-version').value.trim();
    const notes   = document.getElementById('changelog-notes').value.trim();

    if (!version || !notes) {
        return popToast("Précise une version et des notes, Agent.", "error");
    }

    const ok = await chaosNotify(
        `Déployer la version ${version} à tous les agents ? B.O.B va hurler.`,
        "⚠️ ALERTE GÉNÉRALE",
        "confirm"
    );
    if (ok) {
        socket.emit('admin-diffuser-changelog', { version, notes });
        document.getElementById('changelog-notes').value = "";
    }
}

// ==========================================================================
//   SETTINGS (dropdown profil + modal paramètres avancés)
// ==========================================================================

export function toggleSettings(event) {
    if (event) event.stopPropagation();
    const menu = document.getElementById('profile-dropdown');
    if (menu.style.display === 'none' || menu.style.display === '') {
        // Fermer le picker de statut s'il est ouvert pour éviter qu'il passe au-dessus
        const statusPicker = document.getElementById('status-picker');
        if (statusPicker) statusPicker.style.display = 'none';
        menu.style.display = 'block';
        window._settingsOpenedAt = Date.now();
        socket.emit('get-user-profile', localStorage.getItem('monChatPseudo'));

        // Swatches couleur
        const elColor = document.getElementById('edit-color');
        const elTheme = document.getElementById('theme-color-picker');
        const swPseudo = document.getElementById('swatch-pseudo');
        const swTheme  = document.getElementById('swatch-theme');
        if (swPseudo && elColor?.value) swPseudo.style.background = elColor.value;
        if (swTheme  && elTheme?.value)  swTheme.style.background  = elTheme.value;

        // Sync grille fond
        const bgSel = document.getElementById('bg-video-select');
        if (bgSel) {
            document.querySelectorAll('#bg-grid .pd-tile').forEach(t =>
                t.classList.toggle('active', t.dataset.value === bgSel.value));
        }
        // Sync grille bannière
        const bannerSel = document.getElementById('edit-banner');
        if (bannerSel) {
            document.querySelectorAll('#banner-grid .pd-tile').forEach(t =>
                t.classList.toggle('active', t.dataset.value === bannerSel.value));
        }
        // Sync previews accordéons
        syncAccPreview('acc-bg', 'bg-grid');
        syncAccPreview('acc-banner', 'banner-grid');

        // Sync avatar preview
        const selfAvatar = document.getElementById('self-avatar');
        const pdAvatar   = document.getElementById('pd-avatar-preview');
        if (selfAvatar && pdAvatar) {
            pdAvatar.style.backgroundImage = selfAvatar.style.backgroundImage || '';
            pdAvatar.style.backgroundColor = selfAvatar.style.backgroundColor || '#161b22';
            const initiale = document.getElementById('self-avatar-initiale');
            pdAvatar.textContent = selfAvatar.style.backgroundImage ? '' : (initiale?.textContent || '?');
        }
    } else {
        fermerSettings();
    }
}

// Fonctions globales pour les tuiles visuelles
function syncAccPreview(accId, gridId) {
    const preview = document.querySelector(`#${accId} .pd-acc-preview`);
    if (!preview) return;
    const activeTile = document.querySelector(`#${gridId} .pd-tile.active`);
    if (activeTile) {
        preview.style.background = activeTile.style.background || '';
        preview.style.backgroundImage = activeTile.style.backgroundImage || '';
        preview.style.backgroundSize = 'cover';
        preview.style.backgroundPosition = 'center';
    } else {
        preview.removeAttribute('style');
    }
}

window.pdToggleAcc = function(id) {
    document.getElementById(id)?.classList.toggle('open');
};

window.pdSelectBg = function(value) {
    document.querySelectorAll('#bg-grid .pd-tile').forEach(t => t.classList.toggle('active', t.dataset.value === value));
    const sel = document.getElementById('bg-video-select');
    if (sel) sel.value = value;
    if (typeof window.selectionnerVideoFond === 'function') window.selectionnerVideoFond(value);
    syncAccPreview('acc-bg', 'bg-grid');
    document.getElementById('acc-bg')?.classList.remove('open');
};
window.pdSelectBanner = function(value) {
    if (value === 'custom') {
        document.getElementById('banner-custom-input')?.click();
        return;
    }
    document.querySelectorAll('#banner-grid .pd-tile').forEach(t => t.classList.toggle('active', t.dataset.value === value));
    const sel = document.getElementById('edit-banner');
    if (sel) sel.value = value;
    syncAccPreview('acc-banner', 'banner-grid');
    document.getElementById('acc-banner')?.classList.remove('open');
};

function _renderBanniereEl(el, banniereId, couleur) {
    el.querySelectorAll('.banner-video').forEach(v => { try { v.pause(); } catch(_) {} v.remove(); });
    const url = (banniereId && banniereId !== 'none' && banniereId !== '1' && String(banniereId) !== 'undefined')
        ? (banniereId.startsWith('/uploads/') ? banniereId : `/img/banners/${banniereId}`)
        : null;
    if (!url) { el.style.background = couleur || '#58a6ff'; return; }
    if (/\.(mp4|webm)$/i.test(url)) {
        el.style.background = 'none';
        el.style.position = 'relative';
        el.style.overflow = 'hidden';
        const vid = document.createElement('video');
        vid.className = 'banner-video';
        vid.src = url; vid.autoplay = true; vid.muted = true; vid.loop = true; vid.playsInline = true;
        el.appendChild(vid);
    } else {
        el.style.background = `url('${url}') center/cover no-repeat`;
    }
}

window.uploaderBanniereCustom = async function(input) {
    const file = input?.files?.[0];
    if (!file) return;
    const pseudo = window.monPseudo;
    if (!pseudo) { if (typeof window.popToast === 'function') window.popToast('Non connecté.', 'error'); return; }

    const fd = new FormData();
    fd.append('bannerFile', file);
    fd.append('pseudo', pseudo);

    if (typeof window.popToast === 'function') window.popToast('Upload en cours…');
    try {
        const resp = await fetch('/api/upload-banner', { method: 'POST', body: fd });
        const data = await resp.json();
        if (data.success && data.banniere_id) {
            // Mettre à jour le select caché (en ajoutant une option dynamique si besoin)
            const sel = document.getElementById('edit-banner');
            if (sel) {
                let opt = sel.querySelector('option[data-custom="1"]');
                if (!opt) { opt = document.createElement('option'); opt.dataset.custom = '1'; sel.appendChild(opt); }
                opt.value = data.banniere_id;
                sel.value = data.banniere_id;
            }
            // Marquer le tile "Perso." comme actif
            document.querySelectorAll('#banner-grid .pd-tile').forEach(t => t.classList.toggle('active', t.dataset.value === 'custom'));
            // Renderer immédiatement dans la carte profil params
            const banner = document.getElementById('params-banner');
            if (banner) _renderBanniereEl(banner, data.banniere_id, document.getElementById('edit-color')?.value);
            syncAccPreview('acc-banner', 'banner-grid');
            document.getElementById('acc-banner')?.classList.remove('open');
            if (typeof window.popToast === 'function') window.popToast('Bannière mise à jour !', 'success');
        } else {
            if (typeof window.popToast === 'function') window.popToast(data.error || "Échec de l'upload.", 'error');
        }
    } catch {
        if (typeof window.popToast === 'function') window.popToast('Erreur réseau lors de l\'upload.', 'error');
    }
    input.value = '';
};

export function fermerSettings() {
    const menu = document.getElementById('profile-dropdown');
    if (menu) menu.style.display = 'none';
}

export function ouvrirParamsAvances(section) {
    fermerSettings();
    document.getElementById('modal-params').style.display = 'flex';
    window._paramsOpenedAt = Date.now();
    switchParamsSection(section || 'compte');
    socket.emit('get-user-profile', localStorage.getItem('monChatPseudo'));
}

export function fermerParamsAvances() {
    document.getElementById('modal-params').style.display = 'none';
}

export function switchParamsSection(section) {
    if (section === 'securite') {
        // Sécurité est maintenant une sous-section de Compte — scroll vers l'ancre
        ['compte', 'notifs', 'appareils', 'connexions'].forEach(s => {
            const sec = document.getElementById('params-section-' + s);
            const nav = document.getElementById('pnav-' + s);
            if (sec) sec.style.display = s === 'compte' ? '' : 'none';
            if (nav) nav.classList.toggle('active', s === 'compte');
        });
        document.getElementById('pnav-securite')?.classList.add('active');
        socket.emit('get-mon-compte');
        setTimeout(() => {
            const anchor = document.getElementById('securite-anchor');
            const main = document.querySelector('.params-main');
            if (anchor && main) main.scrollTo({ top: anchor.offsetTop - 16, behavior: 'smooth' });
        }, 60);
        return;
    }

    ['compte', 'notifs', 'appareils', 'connexions'].forEach(s => {
        const sec = document.getElementById('params-section-' + s);
        const nav = document.getElementById('pnav-' + s);
        if (sec) sec.style.display = s === section ? '' : 'none';
        if (nav) nav.classList.toggle('active', s === section);
    });
    document.getElementById('pnav-securite')?.classList.remove('active');

    if (section === 'notifs')    chargerPrefsNotif();
    if (section === 'appareils') socket.emit('get-mes-appareils');
    if (section === 'connexions') socket.emit('spotify-status');
    if (section === 'compte')    socket.emit('get-mon-compte');
}

// ==========================================================================
//   PRÉFÉRENCES DE NOTIFICATIONS
// ==========================================================================

export const NOTIF_DEFAULTS = { mp: true, mentions: true, spheres: false, appels: true, sons: true };

export function chargerPrefsNotif() {
    const prefs = Object.assign({}, NOTIF_DEFAULTS, JSON.parse(localStorage.getItem('chaos_notif_prefs') || '{}'));
    Object.keys(NOTIF_DEFAULTS).forEach(k => {
        const el = document.getElementById('notif-toggle-' + k);
        if (el) el.checked = !!prefs[k];
    });
}

export function sauvegarderPrefNotif(key, val) {
    const prefs = Object.assign({}, NOTIF_DEFAULTS, JSON.parse(localStorage.getItem('chaos_notif_prefs') || '{}'));
    prefs[key] = val;
    localStorage.setItem('chaos_notif_prefs', JSON.stringify(prefs));
    if (typeof window._pousserPrefs === 'function') window._pousserPrefs({ notif_prefs: prefs });
}

export function getNotifPref(key) {
    const prefs = Object.assign({}, NOTIF_DEFAULTS, JSON.parse(localStorage.getItem('chaos_notif_prefs') || '{}'));
    return !!prefs[key];
}
